import React from "react";
import { Route, Redirect } from "react-router-dom";
import { renderComponent } from "./path";

const renderRouter = (props, isAuth, type) => {
	const token = localStorage.getItem("token");
	if (!isAuth || token) {
		return renderComponent(type, props);
	}
	return <Redirect to="/" />;
};

const PrivateRoute = ({ ...props }) => {
	const { isAuth, type } = props;
	return (
		<Route {...props} render={props => renderRouter(props, isAuth, type)} />
	);
};

export default PrivateRoute;
